import { DateTime } from 'luxon';
import { AbstractViewModel } from '../../abstract.view.model';
import { CardApiModel } from '../../api-model/card/card.api.model';
import { CardTypeViewModel } from './card-type.view.model';

export class CardViewModel extends AbstractViewModel<CardApiModel> {
  public id: string = null;
  public name: string = null;
  public pointBalance: number = null;
  public valueBalance: number = null;
  public cardTypeId: string = null;
  public clientId: string = null;
  public status: number = null;
  public issueDate: DateTime = null;
  public salesChannelId: string = null;
  public cardBatchId: string = null;
  public flgUseInLocal: number = null;
  public cinemaId: string = null;
  public expireDate: DateTime = null;
  public message: string = null;
  public templateId: string = null;
  public isHidden: boolean = null;
  public type: number;

  public picture: string = null;
  public cardType: CardTypeViewModel = null;

  paymentMethods: {
    id: string;
    name: string;
  }[] = null;

  constructor(protected apiModel: CardApiModel = new CardApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.id = this.apiModel.id;
    this.name = this.apiModel.name;
    this.pointBalance = this.apiModel.pointBalance;
    this.valueBalance = this.apiModel.valueBalance;
    this.cardTypeId = this.apiModel.cardTypeId;
    this.clientId = this.apiModel.clientId;
    this.status = this.apiModel.status;
    this.issueDate = this.apiModel.issueDate;
    this.salesChannelId = this.apiModel.salesChannelId;
    this.cardBatchId = this.apiModel.cardBatchId;
    this.flgUseInLocal = this.apiModel.flgUseInLocal;
    this.cinemaId = this.apiModel.cinemaId;
    this.expireDate = this.apiModel.expireDate;
    this.message = this.apiModel.message;
    this.templateId = this.apiModel.templateId;
    this.isHidden = this.apiModel.isHidden;
    this.type = this.apiModel.type;
    this.picture = this.apiModel.graphic;

    this.paymentMethods = this.apiModel.paymentMethods;
  }

  toApiModel(): CardApiModel {
    return undefined;
  }
}
